import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LinkedService, IViolation } from 'shell-models-lib';

import { TeradataLinkedService } from '../linkedservice/teradata.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.relationalTable.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.RelationalTable_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.RelationalTable_DisplayText)
    ]
})
export class RelationalTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL,
        constraint: {
            required: true,
            validator: async (dataset: RelationalTableDataset, linkedService: LinkedService): Promise<IViolation[] | undefined> => {
                const result: IViolation[] = [];
                if (linkedService instanceof TeradataLinkedService && !linkedService.isMashupResource) {
                    result.push({
                        context: dataset,
                        message: () => stringResources.TeradataV1ReferenceNewLinkedServiceErrorMessage,
                        doNotAutomaticallyCorrect: true
                    });
                }
                return result;
            }
        }
    })
    public linkedService: LinkedService;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = false;
    }
}
